const getters = {
  language: state => state.app.language,
  theme: state => state.app.theme,
  loading: state => state.app.loading,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  userInfo: state => state.user.userInfo,
  balance: state => state.account.balance,
  userBalance: state => state.account.balance, // 为 BalanceDisplay 组件添加
  proxyList: state => state.proxy.list,
  transactionList: state => state.billing.transactions,
  dashboardStats: state => state.dashboard.stats
}

export default getters
